import styled from 'styled-components'

import { TypeStyle, fromMd } from '@syconium/little-miss-figgy'

import { ProductPageDetailsSectionSidePaddedSection } from '../ProductPage.client'

export const Layout = styled.div`
  display: flex;
`

export const Content = styled.div`
  flex: 1;
  min-width: 256px;
  margin-bottom: ${o => o.theme.spacing(3)};
  ${fromMd} {
    margin: 0 auto;
    max-width: 488px;
  }
`

export const AddToBagButtonContainer = styled(ProductPageDetailsSectionSidePaddedSection)`
  display: flex;
  margin-top: ${o => o.theme.spacing(6)};
  gap: ${o => o.theme.spacing(1)};
`

export const SectionLabelWrapper = styled.div`
  align-items: center;
  display: flex;
  position: relative;

  ${fromMd} {
    margin: 0;
  }
`
//TODO: introduce correct typography tokens for these sections
export const SectionTitle = styled(TypeStyle.HeadlineMicro)<{
  isInvalid?: boolean
}>`
  color: ${o => o.isInvalid && o.theme.color.deprecated.red.error};
  font-weight: 700;
  text-transform: uppercase;
`

export const SecondarySectionTitle = styled(TypeStyle.HeadlineExtraExtraSmall)`
  color: ${o => o.theme.color.deprecated.obsidian};
  font-weight: bold;

  ${fromMd} {
    font-size: 14px;
    letter-spacing: 0.15em;
    line-height: 1.7;
  }
`

export const SectionSubtitle = styled(TypeStyle.HeadlineMicro)`
  color: ${o => o.theme.color.deprecated.obsidianLighter};
  margin-inline-start: 16px;
  font-weight: 400;
  ${fromMd} {
    margin-inline-start: 8px;
  }
`

export const ProductDetailsCopy = styled.blockquote<{
  secondary?: boolean
}>`
  ${TypeStyle.css.headlineMicro}
  color: ${o => o.secondary && o.theme.color.deprecated.obsidianLighter};
  padding: 0 ${o => o.theme.dimensions.layout.sidePadding.md}px;

  ${fromMd} {
    padding: 0;
  }
`

export const Separator = styled.div`
  border-top: 1px solid ${o => o.theme.color.deprecated.stoneLight};
  margin: 20px 0;
`

export const UnderlinedLink = styled.span`
  text-decoration: underline;
`

export const BoldText = styled.span`
  font-weight: bold;
`

/* Shared promo text component. Displayed in `GarmentDetails` for site-wide promo, `PortalGarmentAttributes` for portal promo */
export const PromoText = styled(TypeStyle.BodyNano)`
  color: ${o => o.theme.color.deprecated.red.error};
  font-weight: 700;
  margin-top: ${o => o.theme.spacing(2)};

  text-transform: uppercase;

  ${fromMd} {
    padding: 0;
  }
`
